<template>
  <div class="row mb-5">
    <div class="col-20">
      <header-info
        :user-data="profile"
        :type-data="profileTypeData"
        :channels="$store.state.channels.items"
      />

      <nav-buttons v-if="$store.state.user.profile.type === 'influencer'" />

      <transition
        name="fade"
        @before-leave="makeAbsolute"
      >
        <router-view
          :channels="channels"
          :user-data="profile"
          :type-data="profileTypeData"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import HeaderInfo from './details-partials/HeaderInfo.vue'
import NavButtons from './details-partials/NavButtons.vue'

export default {
  components: {
    'header-info': HeaderInfo,
    'nav-buttons': NavButtons
  },
  computed: {
    profile () {
      return this.$store.state.user.profile
    },
    profileTypeData () {
      return this.$store.state.user.profileTypeData
    },
    channels () {
      return this.$store.state.channels.items || []
    }
  },
  beforeMount: function () {
    this.$store.dispatch('channels/getList').catch(() => {})
  }
}
</script>

<style lang="scss" scoped>

</style>
